import React from 'react';
import { Button, ButtonProps } from '@cp/ds/src/components/button';
import { SignoutIcon } from '@cp/ds/src/icons';
import { useLogout } from '../model';

export interface LogoutButtonProps extends ButtonProps {}
export const LogoutButton: React.FC<LogoutButtonProps> = (props) => {
  const logout = useLogout();
  return (
    <Button onClick={logout} {...props}>
      <span>Выйти</span>
      <SignoutIcon fontSize="1.5rem" sx={{ ml: 1 }} />
    </Button>
  );
};
